export default class PublicationVersion {
    constructor() {
        this.init();
    }

    init() {
        this.control();
    }

    control() {
        let url = new URL(window.location.href);

        if (url.href.includes('paRef')) {
            url.searchParams.delete('paRef');
            history.replaceState('', '', url.href);
        }
    }
}
